// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-ghost btn-color-favorite\" id=\"searchBtn\"> <i class=\"fa fa-star\"></i> Favorite </a>";
// Exports
export default code;